import React from 'react';
import { withRouter } from 'react-router-dom';

import { getPlayerName } from '../../../utils';
import styles from './teamRoleCard.scss';
import BackgroundImage from '../../BackgroundImage';
import Img from '../../Img';

const TeamRoleCard = ({
    teamRole,
    clubOrganizers,
    customClassNames,
    user,
    sendMessage,
    history,
    isCollege,
    playerId,
    showPaidHitButton,
    'data-testid': dataTestId,
}) => {
    const organizer = clubOrganizers?.find(({ memberId }) => memberId === teamRole.memberId);
    const showPaidHit = isCollege && showPaidHitButton && playerId;

    const handleOnPaidHitButtonClicked = () => {
        history.push(`/profiles/${playerId}`);
    };

    return (
        <div className={`${styles.teamRole} ${customClassNames || ''}`}>
            <div className={`d-flex organizer-card`}>
                <BackgroundImage
                    baseUrl={'/v1/player/'}
                    defaultImage={'/img/v2/icons/icon-avatar-player.svg'}
                    images={organizer ? organizer.playerProfileImages : null}
                    imageType={'icon'}
                    parentStylesClass={styles.avatar}
                />
                <div className={`person-details`}>
                    <div className={`text-medium text-dark text-line-break`} data-testid={dataTestId && `${dataTestId}.name`}>
                        {getPlayerName(teamRole.firstName, teamRole.lastName, false)}
                    </div>
                    <div className={`text-small text-uppercase`} data-testid={dataTestId && `${dataTestId}.role-label`}>
                        {teamRole.teamRoleType.label}
                    </div>
                </div>
                <div className="message">
                    {(teamRole.member && teamRole.memberId && user && user.id && user.id !== teamRole.memberId) && (
                        <div className={`click-area click-area-36`} onClick={() => sendMessage(teamRole.member)} data-testid={dataTestId && `${dataTestId}.send-message-btn`}>
                            <i className={`utr utr-message fs24 text-teal`} />
                        </div>
                    )}
                </div>
                <div className="message">
                    {showPaidHit && (
                        <div className={`click-area click-area-36`} onClick={handleOnPaidHitButtonClicked} data-testid={dataTestId && `${dataTestId}.paid-hit-btn`}>
                            <Img src="/img/v2/icons/icon-paid-hit.svg" data-testid={dataTestId && `${dataTestId}.paid-hit-icon`} />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

TeamRoleCard.defaultProps = {
    'data-testid': null,
};

export default withRouter(TeamRoleCard);
